import { BaseService } from "../../../../global/classes";
import { FormValuesSingleCharge, NewSingleChargeItem, PatchSingleChargeItem } from "../types";
import { bffApi } from "../../../../services/bff/bffApi";

export default class SingleChargeService extends BaseService {

createSingleCharge = async (data: NewSingleChargeItem) => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const email = userInfo.email || "usuario_padrao";

  return bffApi.post(
    `/api/gcb/v1/manualbilling/manualBillings`,
    {
      merchantId: data.merchantId,
    value: data.value,
    reason: data.reason,
    createdBy: data.createdBy,
    createdAt: data.createdAt,
    finishDate: data.finishDate
    }
  );
};

updateSingleCharge = async (data: PatchSingleChargeItem) => {
  return bffApi.put(
    `/api/gcb/v1/manualbilling/manualBillings/${data.id}`,
    {
      reason: data.reason,
      updatedAt: data.updatedAt,
      updatedBy: data.updatedBy,
    }
  );
};


getSingleCharge = async (
  page: number,
  pageSize: number,
  filter?: FormValuesSingleCharge
) => {
  const paged = true;
  const month = filter?.month || null;
  const year = filter?.year || null;

  const merchantId =
    this.selectedCompany?.merchantId ?? filter?.merchantId ?? null;

  const commercialHierId = null;
  const commercialUserEmail = this.commercialUserEmail;

  return bffApi.get(
    `/api/gcb/v1/manualbilling/getmanualbillings`,
    {
      params: {
        currentPage: page,
        pageSize: pageSize,
        paged: paged,
        month: month,
        year: year,
        merchantId: merchantId,
        commercialHierId: commercialHierId,
        email: commercialUserEmail,
      },
    }
  );
};

  downloadSingleChargeXls = async (filter?: FormValuesSingleCharge) => {
    const paged = false;
    const month = filter?.month || null;
    const year = filter?.year || null;
    const merchantId = this.selectedCompany?.merchantId ?? filter?.merchantId ?? null;
    const commercialUserEmail = this.commercialUserEmail;

    try {
      const response = await bffApi.get(
        `/api/gcb/v1/manualbilling/manualbillingpanel-xls`, {
        params: {
          paged: paged,
          month: month,
          year: year,
          merchantId: merchantId,
          email: commercialUserEmail,
          forDownload: true,
        },
        responseType: "blob",
      }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  };
}
